export const displayCriteriaFields = {
  orderNetValue: 'order_net_value',
  shipmentWeight: 'shipment_weight',
}

export const criteriaMatchTypes = {
  greaterThan: 'greater_than',
  lowerThan: 'lower_than',
  valueInRange: 'value_in_range',
}
